import React, { Component } from 'react';
import { TrevorIcon } from '@trevor/ui-components';
import { datasourceId, userAction } from '@/util/helpers/ajax-helpers';
import { rootDomain } from '@/util/helpers/essential-helpers';
import ShareIcon from './ShareIcon';

class CopyIcon extends Component {
  constructor(props) {
    super(props);
    this.state = {
      copied: false,
    };
    this.inputToCopy = React.createRef();
    this.copyToClipboard = this.copyToClipboard.bind(this);
  }

  componentDidUpdate() {
    if (this.state.copied) {
      this._timer = setTimeout(() => {
        this.setState({
          copied: false,
        });
      }, 2500);
    }
  }

  componentWillUnmount() {
    clearTimeout(this._timer);
  }

  copyToClipboard() {
    const { action, actionMeta } = this.props;

    try {
      this.inputToCopy.current.select();
      const successful = document.execCommand('copy');
      userAction(action || 'use-copy-url', actionMeta || {});
      this.setState({
        copied: successful,
      });
    } catch (err) {
      alert(err);
    }
  }

  render() {
    const {
      lastLoadedView,
      rowRequestId,
      isMap,
      isDashboard,
      isDashboardRefresh,
      dashboardID,
      link,
      disabled,
    } = this.props;

    let path = link;
    if (!link) {
      path = isMap
        ? `/datasources/${datasourceId()}#m=ap`
        : isDashboard
        ? `/datasources/${datasourceId()}/dashboards/${dashboardID}/open`
        : lastLoadedView
        ? `/share/v/${lastLoadedView.series()}`
        : `/share/r/${rowRequestId}`;
    }

    // TODO: We should handle better when to disable the button. Right now we need a new property for each type of content
    const disable = !(
      !disabled &&
      (lastLoadedView ||
        rowRequestId ||
        isMap ||
        isDashboard ||
        isDashboardRefresh)
    );

    return (
      <div className="position-relative">
        <ShareIcon
          key={this.state.copied ? 'copied!' : this.props.tooltip}
          disabled={disable}
          disabledTip={this.props.disabledTip || '(query still running)'}
          id={this.props.id}
          tooltip={this.state.copied ? 'Copied!' : this.props.tooltip}
          onClick={this.copyToClipboard}
          style={{ zIndex: 1 }}
        >
          <TrevorIcon name={this.props.icon} />
        </ShareIcon>
        <input
          type="text"
          style={{
            width: '10px',
            height: '10px',
            position: 'absolute',
            top: '50%',
            left: '50%',
            zIndex: -1,
          }}
          value={rootDomain() + path}
          readOnly
          ref={this.inputToCopy}
        />
      </div>
    );
  }
}

export default CopyIcon;
